import React, {FunctionComponent, PropsWithChildren} from 'react';
import {InvoiceProvider} from "../../context/InvoiceContext";
import {CardFeeRecoveryProvider} from "../../context/CardFeeRecoveryContext";
import {AcornProvider} from "../../context/AcornContext";
import {BankOfAmericaProvider} from "../../context/BankOfAmericaContext";
import {RainforestProvider} from "../../context/RainforestContext";
import {FullstackProvider} from "../../context/FullstackContext";
import {NmiProvider} from "../../context/NmiContext";
import {CompanyProvider} from "../../context/CompanyContext";
import {ItemsProvider} from "../../context/ItemsContext";
import {AddOnItemsProvider} from "../../context/AddOnItemsContext";
import {CustomerProvider} from "../../context/CustomerContext";
import {WisetackProvider} from "../../context/WisetackContext";
import {OptionProvider} from "../../context/OptionContext";
import {FileProvider} from "../../context/FileContext";

export const InvoiceProviders: FunctionComponent<PropsWithChildren> = ({children}) => {
    return (
        <InvoiceProvider>
            <CardFeeRecoveryProvider>
                <AcornProvider>
                    <BankOfAmericaProvider>
                        <RainforestProvider>
                            <FullstackProvider>
                                <NmiProvider>
                                    <CompanyProvider>
                                        <ItemsProvider>
                                            <AddOnItemsProvider>
                                                <CustomerProvider>
                                                    <WisetackProvider>
                                                        <OptionProvider>
                                                            <FileProvider>
                                                                {children}
                                                            </FileProvider>
                                                        </OptionProvider>
                                                    </WisetackProvider>
                                                </CustomerProvider>
                                            </AddOnItemsProvider>
                                        </ItemsProvider>
                                    </CompanyProvider>
                                </NmiProvider>
                            </FullstackProvider>
                        </RainforestProvider>
                    </BankOfAmericaProvider>
                </AcornProvider>
            </CardFeeRecoveryProvider>
        </InvoiceProvider>
    );
};
